import { Stack, type SxProps, Tooltip } from '@mui/material';

import { campaignManagerTheme } from '@campaign-manager/theme';

import UpcaseFirstLabel from '../UpcaseFirstLabel';

export type BulletLabelColor = keyof typeof campaignManagerTheme.color | undefined;

interface Props {
  color: BulletLabelColor;
  label?: string | undefined;
  tooltip?: string | undefined;
  disabled?: boolean;
  sx?: SxProps;
}

export default function BulletLabel({ color, label, tooltip, disabled, sx }: Props) {
  return (
    <Tooltip title={tooltip}>
      <Stack
        direction="row"
        sx={{
          gap: 1,
          alignItems: 'center',
          ...sx,
        }}
      >
        <div
          style={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: color
              ? campaignManagerTheme.color[color]
              : campaignManagerTheme.color.grey,
            color: disabled ? campaignManagerTheme.color.grey : 'inherit',
          }}
        />
        <UpcaseFirstLabel text={label} />
      </Stack>
    </Tooltip>
  );
}
